<header class="go-page-title">
  <h1 class="go-heading-1">Tabs</h1>
  <a
  [href]="linkToSource"
  target="_blank">
    <go-button buttonVariant="neutral"> View on GitHub </go-button>
  </a>
</header>

<section class="go-container">
  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <!-- Intro -->
        <p class="go-body-copy">The Go Tab Component should be used when multiple sets of data need to be rendered, but vertical space is a concern.</p>
  
        <p class="go-body-copy">
          The <code class="code-block--inline">go-tab-group</code> element must be accompanied by
          <code class="code-block--inline">go-tab</code> children.
        </p>
      </div>

      <div class="go-column go-column--100">
        <!-- Bindings -->
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <!-- theme -->
        <h4 class="go-heading-4">theme</h4>
        <p class="go-body-copy">
          <code class="code-block--inline">theme</code> will set the appearance of the <code class="code-block--inline">tab</code>. 
          <code class="code-block--inline">light</code> is the default <code class="code-block--inline">theme</code>
          and should be used in most places. The only time the <code class="code-block--inline">dark</code> theme should be 
          used is when the tab lives inside a UI element that has a dark themed background by default.
        </p>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="default">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Default</h2>
      <go-copy cardId="default" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content class="go-container">
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">Code</h4>
        <code [highlight]="defaultExample"></code>
      </div>
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">View</h4>
        <go-tab-group>
          <go-tab heading="Tab 1">
            This is some content for <b>Test 1</b>.
          </go-tab>
          <go-tab heading="Tab 2">
            This is a second thing.
          </go-tab>
          <go-tab heading="Tab 3">
            This is a third thing. 
          </go-tab>
        </go-tab-group>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="theme">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Theme</h2>
      <go-copy cardId="theme" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content class="go-container">
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">Code</h4>
        <code [highlight]="darkExample"></code>
      </div>
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">View</h4>
        <go-tab-group theme="dark">
          <go-tab heading="Tab 1">
            This is some content for <b>Test 1</b>.
          </go-tab>
          <go-tab heading="Tab 2">
            This is a second thing.
          </go-tab>
          <go-tab heading="Tab 3">
            This is a third thing. 
          </go-tab>
        </go-tab-group>
      </div>
    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="lazy-loading">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Lazy Loading</h2>
      <go-copy cardId="lazy-loading" goCopyCardLink></go-copy>
    </ng-container>
    <div go-card-content class="go-container">
      <div class="go-column go-column--100">
        <p class="go-body-copy">
          By default, components rendered inside of the tabs are eager loaded. This means they will
          be initialized when the page get's loaded. The tab content can be lazy loaded by adding a
          ng-template to the body of the content
        </p>
      </div>
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">Code</h4>
        <code [highlight]="lazyLoadExample"></code>
      </div>
      <div class="go-column go-column--50">
        <h4 class="go-heading-4 go-heading--underlined">View</h4>
        <go-tab-group>
          <go-tab heading="Tab 1">
            <ng-template #tabContent>
              This is some content for <b>Test 1</b>.
            </ng-template>
          </go-tab>
          <go-tab heading="Tab 2">
            <ng-template #tabContent>
              This is a second thing.
            </ng-template>
          </go-tab>
          <go-tab heading="Tab 3">
            <ng-template #tabContent>
              This is a third thing. 
            </ng-template>
          </go-tab>
        </go-tab-group>
      </div>
    </div>
  </go-card>
</section>
